export default {
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    "$route.hash"(newHash, oldHash) {
      if (newHash != "") {
        this.dialog = true;
      } else if (oldHash != "") {
        this.dialog = false;
      }
    },
    dialog(newValue) {
      let hash = this.$route.hash
      if (hash != "" && newValue == false) {
        let count = hash.substring(1, hash.length);
        for (let i = 0; i < count; i++) {
          this.$router.back()
        }
      }
    }
  },
  methods: {
    toggleDialog(open) {
      if (open) {
        if (this.$route.hash != "") {
          this.dialog = true;
        } else {
          this.$router.push("#1");
        }
      } else {
        this.$router.back();
      }
    },
  },
}